import 'wowjs/dist/wow.js';

const WOWConstructor = typeof window !== 'undefined' ? window.WOW : undefined;

document.addEventListener('DOMContentLoaded', function () {
	if (typeof WOWConstructor === 'function') {
		new WOWConstructor({
			boxClass: 'wow',
			animateClass: 'animate__animated',
			offset: 80,
			mobile: true,
			live: false
		}).init();
	}

	var updateScrollState = function () {
		document.body.classList.toggle('aoide-scrolled', window.scrollY > 20);
	};

	updateScrollState();
	window.addEventListener('scroll', updateScrollState, { passive: true });
});